import { createSlice } from "@reduxjs/toolkit";

const mainSlice = createSlice({
  name: "main",
  initialState: {
    userLogin: false,
    currentUser: {},
    employers: false,
    branches: false,
  },
  reducers: {
    userAdd(state, action) {
      state.currentUser = action.payload;
      localStorage.setItem("userLogin", true);
      localStorage.setItem("userToken", action.payload.token);
    },
    userLogin(state, action) {
      state.userLogin = action.payload;
    },
    employersAdd(state, action) {
      state.employers = action.payload;
    },
    branchesAdd(state, action) {
      state.branches = action.payload;
    },
  },
});

export const { userAdd, userLogin, employersAdd, branchesAdd } =
  mainSlice.actions;
export default mainSlice.reducer;
